export const SITEMAPURLS = [
  {name: 'Inicio', url: ''},
  {name: 'Encuentra un Ortodoncista', url: 'encuentra-ortodoncista'},
  {name: 'Soy Ortodoncista', url: 'soy-ortodoncista'},
  {name: 'FAQ', url: 'faq'}
];

export const CONTACTDATA = [
  {content: "(81) 1588 - 3986", iconClass: "fa fa-phone"},
  {content: "Av. Vasconcelos 124 Col. Tampiquito, San Pedro Garza Garcia, Mexico.", iconClass: "fa fa-map-marker"},
  {content: "(81) 1588 - 3986", iconClass: "fa fa-whatsapp"},
  {content: "hola@aliwell.mx", iconClass: "fa fa-envelope"},
];

// Aviso de privacidad oficial: vive en el sitio público, no dentro del sistema
export const PRIVACYNOTICEURL = 'https://aliwell.mx/aviso-de-privacidad/';
